module.exports = __webpack_public_path__ + "assets/img/32_639_big.83f95f09.jpg";